<template>
  <span v-help.mouse="help"
        class="boolgrid-switch"
        :class="{'true': value === true, 'false': value === false}"
        @click="toggle"
  >
    <div class="slider"></div>
  </span>
</template>

<script>
export default {
    name: 'UISwitch',
    props: {
        value: {
            type: Boolean,
            required: true,
            default: () => null,
        },
    },
    computed: {
        help() {
            if (this.value === true) {
                return 'Zapnuto, kliknutím vypněte.'
            }
            if (this.value === false) {
                return 'Vypnuto, kliknutím zapněte.'
            }
            return 'Neznámý stav, zjevně hodnota není ani zapnuto ani vypnuto. Kliknutím zapněte.'
        },
    },
    methods: {
        toggle() {
            this.$emit('input', !this.value)
        },
    },
}
</script>

<style lang="scss" scoped>
.boolgrid-switch {
    display: inline-block;
    width: 40px;
    height: 20px;
    border: 1px solid var(--color-input-border);
    padding: 1px;
    cursor: pointer;
    border-radius: 10px;
    transition: all 100ms;
    & > .slider {
        width: 16px;
        height: 16px;
        transition: all 150ms;
        border-radius: 50%;
        border: 1px solid var(--color-input-border);
        background-color: white;
        transform: translate(10px,0);
    }
    &.true {
        background: linear-gradient(0deg, rgba(21,227,0,1) 0%, rgba(22,146,0,1) 100%);
        & > .slider {
            transform: translate(0px,0);
        }
    }
    &.false {
        background: linear-gradient(0deg, rgba(225,0,1,1) 0%, rgba(156,0,4,1) 100%);
        & > .slider {
            transform: translate(20px,0);
        }
    }
}
</style>

